import { ReactElement } from 'react';
import { LuBookOpen, LuChartNoAxesCombined, LuFiles, LuListChecks } from 'react-icons/lu';

const iconFactories: Record<string, () => ReactElement> = {
    tasks: () => <LuListChecks size={20} strokeWidth={1.7} aria-hidden="true" />,
    docs: () => <LuFiles size={20} strokeWidth={1.7} aria-hidden="true" />,
    reports: () => <LuChartNoAxesCombined size={20} strokeWidth={1.7} aria-hidden="true" />,
    dicts: () => <LuBookOpen size={20} strokeWidth={1.7} aria-hidden="true" />,
};

export const getSystemFolderIcon = (name: string): ReactElement | null => iconFactories[name]?.() ?? null;
